import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import { scrollToFirstError } from "@/Mixins/scrollToFirstError";

/**
 * bug 41: глобально следит за ошибками валидации (общий бэг Inertia usePage().props.errors)
 * и прокручивает/фокусирует первое поле с ошибкой. Монтируется один раз в AppLayout —
 * покрывает все формы (админ CRUD, модалки, auth, профиль). Рендерит null.
 */
export default function ScrollToFirstError() {
    const { errors } = usePage().props as any;

    // Зависимость — идентичность объекта errors, а НЕ его сериализация. Inertia отдаёт новый
    // объект errors на каждый ответ сервера (в т.ч. при повторной отправке с теми же ошибками),
    // но он стабилен между локальными ре-рендерами. Так скролл срабатывает и на повторной
    // идентичной ошибке (главный кейс bug 41), и не даёт лишних срабатываний на страницах без форм.
    useEffect(() => {
        if (errors && Object.keys(errors).length) {
            // Небольшая задержка — чтобы модалка/DOM успели отрисовать поле с ошибкой.
            const t = setTimeout(() => scrollToFirstError(errors), 60);
            return () => clearTimeout(t);
        }
    }, [errors]);

    return null;
}
